import GeografiaMasterPage from './GeografiaMasterPage.jsx';
import { createProvincia, deactivateProvincia, listProvincias, updateProvincia } from '@/services/geografia.js';

export default function ProvinciasPage() {
  return <GeografiaMasterPage title="Provincias" singular="Provincia" description="Maestro de provincias para la clasificación de localidades y direcciones." list={listProvincias} create={createProvincia} update={updateProvincia} deactivate={deactivateProvincia} showLocalidades />;
}
